var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWheelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8A7 7 0 113 8a7 7 0 0114 0zm-2 0c0 1.02-.305 1.967-.828 2.757l-2.24-2.239a2.006 2.006 0 000-1.036l2.24-2.24C14.695 6.034 15 6.982 15 8zm-4.482 1.932l2.24 2.24A4.977 4.977 0 0110 13a4.977 4.977 0 01-2.757-.828l2.239-2.24a2.003 2.003 0 001.036 0zM10 6c-.18 0-.353.024-.518.068l-2.24-2.24a4.971 4.971 0 011.817-.74L10 4.5l.941-1.412c.66.126 1.275.382 1.816.74l-2.239 2.24A2.002 2.002 0 0010 6zM8.068 7.482l-2.24-2.24A4.977 4.977 0 005 8c0 1.02.305 1.967.828 2.757l2.24-2.239a2.003 2.003 0 010-1.036zM5 17h3l1-1h2l1 1h3l1 1-1 1H5.002l-1-1L5 17z",
    fill: "#9A9CAC"
  })));
}

export default SvgWheelIcon;